import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { checkAuth } from './api';
import Login from './pages/Login';
import SuperAdminLayout from './layout/SuperAdminLayout';
import Dashboard from './pages/Dashboard';
import Organizations from './pages/Organizations';
import Users from './pages/Users';
import TimeEntries from './pages/TimeEntries';
import Audit from './pages/Audit';
import NotificationDiagnostics from './pages/NotificationDiagnostics';
import SystemStatus from './pages/SystemStatus';
import Backups from './pages/Backups';
import ChangePassword from './pages/ChangePassword';
import Security from './pages/Security';
import './App.css';

function RequireAuth({ children }) {
  const [status, setStatus] = useState('loading');
  useEffect(() => {
    checkAuth()
      .then((r) => setStatus(r.ok ? 'ok' : 'unauthorized'))
      .catch(() => setStatus('unauthorized'));
  }, []);
  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        Cargando…
      </div>
    );
  }
  if (status === 'unauthorized') return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <SuperAdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="organizations" element={<Organizations />} />
        <Route path="users" element={<Users />} />
        <Route path="time-entries" element={<TimeEntries />} />
        <Route path="audit" element={<Audit />} />
        <Route path="notification-diagnostics" element={<NotificationDiagnostics />} />
        <Route path="system-status" element={<SystemStatus />} />
        <Route path="backups" element={<Backups />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="security" element={<Security />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
